import { z } from 'zod';

export const ZIP_REGEX = /^\d{5}(-\d{4})?$/;

export const PHONE_REGEX =
  /^(?:\+?1[\s.-]?)?(?:\(?([2-9]\d{2})\)?)[\s.-]?([2-9]\d{2})[\s.-]?(\d{4})(?:\s*(?:x|ext\.?|#)\s*\d{1,10})?$/;

export const PHONE_STRING = z.string().max(20, 'Must not exceed 20 characters');

export const EMAIL_ADDRESS = z
  .string()
  .email('Must be a valid email address')
  .max(255, 'Must not exceed 255 characters');

export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]*$/;

export const OPTIONAL_SHORT_STRING = z.string().trim().max(500, 'Must not exceed 500 characters');

export const SHORT_STRING = OPTIONAL_SHORT_STRING.min(1, 'Required');

export const OPTIONAL_LONG_STRING = z
  .string()
  .trim()
  .max(15000, 'Must not exceed 15,000 characters');

export const LONG_STRING = OPTIONAL_LONG_STRING.min(1, 'Required');

export const NULLABLE_STRING_TO_NUMBER = z
  .string()
  .optional()
  .transform((id) => (id ? parseInt(id, 10) : null))
  .pipe(z.number().nullable());

// Use this when you want an empty field to be set to NULL in the database
// on an UPDATE. The default behavior of Conform is to preprocess "" into
// undefined, resulting in that column being ignored in update statements.
// https://conform.guide/api/zod/parseWithZod#tips
// https://github.com/colinhacks/zod/issues/1721
export const nullableField = <Output, Def extends z.ZodTypeDef, Input>(
  t: z.ZodType<Output, Def, Input>,
) =>
  z.preprocess((v: unknown) => {
    const isEmpty =
      (typeof v == 'number' && isNaN(v)) ||
      (typeof v == 'string' && v === '') ||
      v === undefined ||
      (Array.isArray(v) && v.length == 0);
    return isEmpty ? null : v;
  }, t.nullable());

export const PG_DATE_STRING = z.string().trim().date();
